import httpService from './httpService';

import { IFund } from './types/IFund';

export const getFunds = (): Promise<IFund[]> => {
  let endpoint = httpService.getEndpointURL('/Funds');
  return httpService.getTyped<IFund[]>(endpoint);
};
